// extracted by mini-css-extract-plugin
export default {"overlay":"NewQuestion_overlay__ng9tW","zoom":"NewQuestion_zoom__OdElr","backButton":"NewQuestion_backButton__ZzZkj","pageText":"NewQuestion_pageText__Sw8C8"};